import { render, staticRenderFns } from "./SaleOrder.vue?vue&type=template&id=c0e68a04&scoped=true&"
import script from "./SaleOrder.vue?vue&type=script&lang=js&"
export * from "./SaleOrder.vue?vue&type=script&lang=js&"
import style0 from "./SaleOrder.vue?vue&type=style&index=0&id=c0e68a04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0e68a04",
  null
  
)

export default component.exports